import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class TeamsSigtripUnread extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      selected_training_id: false,
      team_id: null,
      staff_id: false,
      dados: [],
      staffs: [],
      turmas: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.span = this.span.bind(this);
    this.addAll = this.addAll.bind(this);
    this.addStaff = this.addStaff.bind(this);
    this.export = this.export.bind(this);
    this.importFull = this.importFull.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/sigtrip/comunicados/nao/lidos', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }


  setAsViewed(id) {
    if (window.confirm('Tem certeza que deseja marcar esse treinamento como visualizado?')) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var url = config.get('api') + '/sigtrip/treinamentos/visualizar/'+id;
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.loadData();
          }
        });
      });
    }
  }

  setModal(id) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var url = config.get('api') + '/sigtrip/treinamentos/info/'+id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            staffs: responseJson.data.data,
            turmas: responseJson.data.turmas,
            selected_training_id: id,
            modal: true,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }
      });
    });
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + url + self.state.selected_training_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn_sigtrip') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  addAll(staff_id) {
    var self = this;
    if(this.state.team_id === null) {
      self.setState({overlay: {message: 'É necessário selecionar uma turma para adicionar colaboradores.', type: 'warning', status: 'open'}});
    } else {
      var datasave = {
        team_id: this.state.team_id,
        staffs: this.state.staffs,
        sigtrip_training_id: this.state.selected_training_id,
      };
      var header = this.refs.request_api.header('application/json');
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var url = config.get('api') + '/sigtrip/treinamentos/todos';
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        });
      });
    }
  }

  addStaff(staff) {
    var self = this;
    if(this.state.team_id === null) {
      self.setState({overlay: {message: 'É necessário selecionar uma turma para adicionar colaboradores.', type: 'warning', status: 'open'}});
    } else {
      var datasave = {
        team_id: this.state.team_id,
        staff_id: staff.staff_id,
        sigtrip_training_id: this.state.selected_training_id,
        training_certification_staff_id: staff.training_certification_staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      var url = config.get('api') + '/turma/treinamento/materia/aluno/importar';
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        });
      });
    }
  }


  importFull() {
    var self = this;
    var datasave = {
      type: 'sigtrip',
      id: this.state.selected_training_id,
    };
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var url = config.get('api') + '/importar/remoto';
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      });
    });
  }

  botaoEdicao (cell, row) {

    var botao = (
      <div>
        <button className={'btn btn-primary btn-sm'} onClick={() => this.setModal(cell)}>
          <i className="fa fa-fw fa-users"></i>
        </button>
        &nbsp;
        <button className={'btn btn-success btn-sm'} onClick={() => this.setAsViewed(cell)}>
          <i className="fa fa-fw fa-eye"></i>
        </button>
      </div>
    );

    return botao;
  }

  span (cell, row) {
    if (row.last_revision_read == 0) {
      var span = (
        <span>
          {row.number}
        </span>
      );
    } else {
      var span = (
        <span className="label label-warning">
          {row.number}
        </span>
      );

    }
    return span;

  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de comunicados não lidos</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há turmas cadastrados',defaultSortName: 'id', defaultSortOrder: 'desc'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='65'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Código</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} width='300' filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Data Inicial</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Data Final</TableHeaderColumn>

        <TableHeaderColumn dataField="number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} dataFormat={this.span} width='120'>Revisão</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='120'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Alunos do treinamento - ID - {this.state.selected_training_id}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, staffs: [], selected_training_id: false, team_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        <Dropdown id="export-data">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> Exportar
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/solo/'}>Solo</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/solo-tic/'}>Solo TIC</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/simulador/'}>Simulador</MenuItem>
            <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/ead/'}>EAD</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <hr/>
      <button className="btn btn-success btn-block" type="button" onClick={() => self.importFull()}><i className="fa fa-fw fa-download"></i> Cadastrar nova turma e inserir alunos</button>
      <hr/>
      <div className="form-group">
        <label>Turma:</label>
        <Select
          className="form-field-name"
          name="team_id"
          value={this.state.team_id}
          searchable={true}
          placeholder={'Selecionar turma'}
          onChange={this.handleSelectChange.bind(this, 'team_id')}
          options={this.state.turmas}
        />
      </div>
      <hr/>
      <button className="btn btn-primary btn-block" type="button" onClick={() => self.addAll()}><i className="fa fa-fw fa-plus"></i> Adicionar todos</button>
      <hr/>
      <div className="info-warning"><i className="fa fa-fw fa-warning"></i> <strong>Atenção!</strong> Somente alunos que existam no SIGTREIN serão adicionados. Alunos já cadastrados nesta turma serão ignorados</div>
      <hr/>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <td>Aluno</td>
            <td>Status</td>
            <td style={{width: '20%', textAlign: 'center'}}>Adicionar</td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(self.state.staffs).map(function(k) {
            return (
              <tr>
                <td style={{width: '40%', textAlign: 'center'}}>{self.state.staffs[k].staff}</td>
                <td style={{width: '40%', textAlign: 'center'}}>
                  {self.state.staffs[k].exists ?
                    <span className="label label-success">cadastrado</span>
                    :
                    <span className="label label-danger">não cadastrado</span>
                  }
                </td>
                <td style={{width: '20%', textAlign: 'center'}}>
                  {self.state.staffs[k].exists &&
                    <button className={'btn btn-primary btn-sm'} onClick={() => self.addStaff(self.state.staffs[k])}>
                      <i className="fa fa-fw fa-plus"></i>
                    </button>
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, staffs: [], selected_training_id: false, team_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default TeamsSigtripUnread;



// WEBPACK FOOTER //
// ./src/Components/Teams/TeamsSigtripUnread.js